<template>
  <div class="page__agency_survey a-page">
    <div style="padding: 10px">
      <el-tag v-if="atosa_device === 'web'" style="margin-bottom: 30px" type="">
        {{ $t('tool.download_app_title') }}
        &nbsp;&nbsp;
        <a href="javascript:void(0)" style="text-decoration: underline !important;"
           @click="EB.$emit('show_download_app_dialog')">{{ $t('tool.download_app') }}!</a>
      </el-tag>

      <div>
        <div style="float: left; width: 30%; font-size: 13px; font-weight: 600">{{ $t('base.keyword') }}</div>
        <div style="float: right; width: 20%; font-size: 13px; font-weight: 600">{{ $t('tool.max_products') }}</div>
        <div style="clear: both"></div>
      </div>
      <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="search_keyword"
                       :fetch-suggestions="m__suggest_keyword" :disabled="loading" style="width: 30%"
                       @keyup.enter.native="m__start_search"></el-autocomplete>
      &nbsp;
      &nbsp;
      <el-button size="mini" type="primary" @click="m__start_search">
        <i :class="loading ? 'el-icon-loading' : 'el-icon-search'"></i> {{
          loading ? $t('tool.click_to_stop') : $t('base.search')
        }}
      </el-button>

      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      <el-radio :disabled="loading" style="margin-top: 5px" v-model="search_by" label="relevancy" size="mini">
        {{ $t('tool.relevance') }}
      </el-radio>
      <el-radio :disabled="loading" style="margin-top: 5px" v-model="search_by" label="ctime" size="mini">
        {{ $t('tool.latest') }}
      </el-radio>
      <el-radio :disabled="loading" style="margin-top: 5px" v-model="search_by" label="sales" size="mini">
        {{ $t('tool.top_sales') }}
      </el-radio>

      <el-input :disabled="loading" v-model="max" type="number" size="mini" :placeholder="$t('tool.max_products')"
                style="width: 20%; float: right"></el-input>
      <br>
      <br>
      <div style="width: 30%; font-size: 13px; font-weight: 600">{{ $t('tool.price_range') }}</div>
      <div style="display: flex">
        <div style="width: 30%;">
          <div style="float: left; width: 45%">
            <el-input type="number" size="mini" :placeholder="$t('tool.min')" v-model="price_min"></el-input>
          </div>
          <div style="float: left; width: 10%; text-align: center">-</div>
          <div style="float: left; width: 45%">
            <el-input type="number" size="mini" :placeholder="$t('tool.max')" v-model="price_max"></el-input>
          </div>
          <div style="clear: both"></div>
        </div>
        <div style="width: 60%; margin-left: 30px">
          <el-select size="mini" value="" v-model="item_type">
            <el-option value="all" :label="$t('base.all_products')"></el-option>
            <el-option value="seo" :label="$t('tool.show_seo_products_only')"></el-option>
          </el-select>
        </div>
      </div>

      <br>
      <div style="clear: both"></div>
      <p style="font-weight: 700; font-size: 14px">{{ $t('tool.category').toUpperCase() }}</p>
      <div v-for="category in category_list" @click="m__select_category(category)"
           :class="m__is_selected_cat(category) ? 'selected_cat' : ''"
           style="width: 10%; display: inline-block; text-align: center; overflow: hidden; cursor: pointer; background-color: #ffffff; color: #000000; padding: 0 5px">
        <img style="width: 55px; height: 55px;" :src="SHOPEE_IMAGE(category.main.image)" alt="">
        <div style="width: 100%; height: 40px; font-size: 12px;">
          {{ category.main.display_name }}
        </div>
      </div>

      <br>
      <p v-if="selected_category" style="font-weight: 700; font-size: 14px">
        {{ $t('tool.category_level').toUpperCase() }} 2</p>
      <div v-for="sub in sub_category_list" :class="m__is_selected_sub_cat(sub) ? 'selected_cat' : ''"
           @click="m__select_sub_category(sub)"
           style="background-color: #999999; padding: 5px 10px; display: inline-block; margin-right: 10px; margin-bottom: 10px; font-weight: 600; color: #ffffff; cursor: pointer">
        {{ sub.display_name }}
      </div>

      <br>
      <p v-if="selected_sub_category" style="font-weight: 700; font-size: 14px">
        {{ $t('tool.category_level').toUpperCase() }} 3</p>
      <div v-for="sub in sub_sub_category_list" :class="m__is_selected_sub_sub_cat(sub) ? 'selected_cat' : ''"
           @click="m__select_sub_sub_category(sub)"
           style="background-color: #999999; padding: 5px 10px; display: inline-block; margin-right: 10px; margin-bottom: 10px; font-weight: 600; color: #ffffff; cursor: pointer">
        {{ sub.display_name }}
      </div>

      <br>
      <br>

      <div class="line-metrics">
        <div class="metric-item">
          <div class="metric-title">{{ $t('metric.total_sold') }}</div>
          <div class="metric-value"><span>{{ m__short_value(historical_sold) }}</span></div>
        </div>
        <div class="metric-item">
          <div class="metric-title">{{ $t('base.sales') }}</div>
          <div class="metric-value"><span>{{ m__short_value(revenue) }}</span></div>
        </div>
        <div class="metric-item">
          <div class="metric-title">{{ $t('tool.aov') }}</div>
          <div class="metric-value"><span>{{ m__short_value(aov) }}</span></div>
        </div>
        <div class="metric-item">
          <div class="metric-title">{{ $t('tool.monthly_sold') }}</div>
          <div class="metric-value"><span>{{ m__short_value(sold) }}</span></div>
        </div>
        <div class="metric-item">
          <div class="metric-title">{{ $t('tool.monthly_sales') }}</div>
          <div class="metric-value"><span>{{ m__short_value(revenue_month) }}</span></div>
        </div>
        <div class="metric-item">
          <div class="metric-title">{{ $t('tool.monthly_aov') }}</div>
          <div class="metric-value"><span>{{ m__short_value(aov_month) }}</span></div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div style="display: flex">
        <div style="flex: 0 1 auto">
          <p style="font-weight: 700; font-size: 14px">
            {{ $t('product.list') }} <span>({{ list_true.length }} {{ $t('base.products') }})</span>
          </p>
        </div>
        <div class="text-right" style="flex: 1; padding-right: 15px">
          <el-button size="mini" @click="m__show_filter_dialog" :disabled="loading">
            <i class="ti-panel"></i>&nbsp; {{ $t('base.filter') }}
            <template v-if="product_filter.some(i => i.value)">
              <strong class="text-success">[ON]</strong>
            </template>
            <template v-else>
              <strong class="text-danger">[OFF]</strong>
            </template>
          </el-button>
          <el-button v-if="!is_filter_buff"
                     size="mini" type="primary" @click="is_filter_buff = true"
                     :disabled="!product_list.length || loading">{{ $t('tool.exclude_buff_products') }}
          </el-button>
          <el-button v-else
                     size="mini" type="danger" @click="is_filter_buff = false"
                     :disabled="!product_list.length || loading">{{ $t('tool.remove_exclude_buff_products') }}
          </el-button>
          <el-button size="mini" icon="el-icon-download" type="primary"
                     :disabled="!product_list.length || loading"
                     @click="m__show_download_excel" :loading="download_loading">{{ $t('base.download_excel') }}
          </el-button>
        </div>
        <el-col :sm="5">
          <el-input size="mini" v-model="filter.keyword" :placeholder="$t('input.placeholder')"
                    prefix-icon="el-icon-search"></el-input>
        </el-col>
      </div>

      <div id="double-scroll-wrapper" style="position: fixed; z-index: 2000; bottom: 1px;">
        <div id="double-scroll-bar">
        </div>
      </div>
      <el-pagination
        :current-page.sync="filter.current_page"
        :page-size="filter.page_size"
        layout="total, prev, pager, next"
        :total="list_true.length">
      </el-pagination>
      <el-table id="main-table" :data="list_display"
                style="width: 100%; overflow-x: scroll" @sort-change="m__sort_change">
        <el-table-column width="65px" :label="$t('base.rank')" show-tooltip-when-overflow>
          <template slot-scope="scope">
            {{ scope.row.index }}
          </template>
        </el-table-column>
        <el-table-column width="65px" show-tooltip-when-overflow>
          <template slot-scope="scope">
            <div style="height: 5px"></div>
            <img :src="SHOPEE_IMAGE(scope.row.image)" alt="logo"
                 style="width:35px; height: 35px;">
            <div style="height: 5px"></div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('product.name')"
          width="250"
          prop="name"
          show-tooltip-when-overflow>
          <template slot-scope="scope">
            <a :href="m__create_product_link(scope.row)" target="_blank">{{ scope.row.name }}</a>
            <div>
              {{ $t('product.type') }}: {{ scope.row.item_type.toUpperCase() }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="130px"
          :label="$t('base.variations')">
          <template slot-scope="scope">
            <el-button type="text" @click="m__show_models_dialog(scope.row)" :loading="loading_get_models"
                       :disabled="loading">
              <strong class="text-primary">{{ $t('tool.show_variations') }}</strong>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('base.price')" sortable
          prop="price_max" width="120px">
          <template slot-scope="scope">
            {{ scope.row.display_price | currency }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('base.discount')"
          prop="discount" sortable>
        </el-table-column>
        <el-table-column
          :label="$t('base.sold')"
          prop="historical_sold"
          width="120" sortable>
        </el-table-column>
        <el-table-column
          :label="$t('tool.monthly_sold')"
          width="140"
          prop="sold" sortable>
        </el-table-column>
        <el-table-column
          :label="$t('base.stock')"
          prop="stock" sortable>
        </el-table-column>
        <el-table-column
          :label="$t('base.created_at')"
          width="130" prop="ctime" sortable>
          <template slot-scope="scope">
            {{ scope.row.ctime * 1000 | moment }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('tool.day_number_creation')"
          width="130" prop="ctime" sortable>
          <template slot-scope="scope">
            {{ m__get_day(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('base.sales')"
          width="120" prop="revenue"
          sortable>
          <template slot-scope="scope">
            {{ scope.row.price_max / 100000 * scope.row.historical_sold | currency }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('tool.monthly_sales')"
          width="160" prop="revenue_month"
          sortable>
          <template slot-scope="scope">
            {{ scope.row.price_max / 100000 * scope.row.sold | currency }}
          </template>
        </el-table-column>
        <el-table-column
          label="Comment"
          width="120" prop="comment" sortable>
        </el-table-column>
        <el-table-column
          :label="$t('tool.comments_sold_rate')"
          width="200" prop="comment_x_historical_sold" sortable>
          <template slot-scope="scope">
            {{ scope.row.comment_x_historical_sold }} %
          </template>
        </el-table-column>
        <el-table-column
          label="Like"
          prop="liked_count" sortable>
        </el-table-column>
        <el-table-column
          label="5 Star"
          width="100" prop="item_rating.rating_count[5]" sortable>
        </el-table-column>
        <el-table-column
          label="Rating"
          width="100" prop="rating" sortable>
          <template slot-scope="scope">
            {{ Math.round(scope.row.item_rating.rating_star) }}
          </template>
        </el-table-column>
        <el-table-column
          label="5 Star"
          width="100" prop="item_rating.rating_count[5]">
        </el-table-column>
        <el-table-column
          label="4 Star"
          width="100" prop="item_rating.rating_count[4]">
        </el-table-column>
        <el-table-column
          label="3 Star"
          width="100" prop="item_rating.rating_count[3]">
        </el-table-column>
        <el-table-column
          label="2 Star"
          width="100" prop="item_rating.rating_count[2]">
        </el-table-column>
        <el-table-column
          label="1 Star"
          width="100" prop="item_rating.rating_count[1]">
        </el-table-column>
        <el-table-column
          :label="$t('base.action')"
          width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="m__remove_product(scope.$index)">
              <strong class="text-danger">{{ $t('base.delete') }}</strong>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination id="main-pagination"
                     :current-page.sync="filter.current_page"
                     :page-size="filter.page_size"
                     layout="total, prev, pager, next"
                     :total="list_true.length">
      </el-pagination>
    </div>

    <el-dialog :visible.sync="show_filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <el-table :data="product_filter">
          <el-table-column :label="$t('base.column')" prop="label">
            <template slot-scope="scope">
              <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{ scope.row.label }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.expression')" prop="expression" width="100px">
            <template slot-scope="scope">
              <el-select class="full-w" size="mini" v-model="scope.row.expression">
                <el-option label=">" value=">"></el-option>
                <el-option label="<" value="<"></el-option>
                <el-option label="=" value="==="></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.value')" prop="value" width="120px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="100px" align="right">
            <template slot-scope="scope">
              <div style="height: 3px"></div>
              <el-button size="mini" type="danger"
                         @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
              </el-button>
              <div style="height: 3px"></div>
            </template>
          </el-table-column>
        </el-table>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
            {{ $t('base.delete_filter') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__start_filter">{{
              $t('base.execute')
            }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="900px" :close-on-click-modal="false" :visible.sync="show_dialog.models"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <strong>{{ $t('base.product') }}: {{ selected_product.name }}</strong>

        <br>
        <el-table
          v-loading="loading_get_models"
          :data="selected_models"
          style="width: 100%; margin-top: 10px; overflow-x: scroll">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            :label="$t('base.variations')"
            prop="name">
          </el-table-column>
          <el-table-column
            :label="$t('base.price')"
            prop="price" sortable>
            <template slot-scope="scope">
              {{ scope.row.price / 100000 | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sold')"
            prop="sold" sortable>
            <template slot-scope="scope">
              {{ scope.row.sold | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sales')"
            prop="gmv" sortable>
            <template slot-scope="scope">
              {{ scope.row.gmv | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.stock')"
            prop="price">
            <template slot-scope="scope">
              {{ scope.row.stock | currency }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="notify" :close-on-click-modal="false"
               custom-class="no-body"
               width="600px">
      <div slot="title" style="padding:10px">
        <div style="text-align: center">
          <strong style="font-size: 18px">{{ $t('base.notice') }}</strong>
        </div>

        <div style="margin-top: 30px; font-size: 14px; line-height: 25px">
          {{ $t('tool.download_app_message') }}
        </div>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="small" @click="EB.$emit('show_download_app_dialog'); notify = false">
            {{ $t('tool.download_app') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {drop as _drop, filter as _filter, take as _take} from 'lodash'
import {check_channel, show_expr_notification} from '../../addon/check_license'
import {shopee_category_list} from '../../addon/shopee_data';
import store from '../../store';

export default {
  name: 'page__agency_survey',

  data() {
    return {
      filter: {
        pages: [10, 20, 50],
        page_size: 20,
        current_page: 0,
        keyword: '',
        total_record: 0
      },
      search_keyword: '',
      max: 300,
      selected_category: '',
      selected_sub_category: '',
      selected_sub_sub_category: '',
      category_list: [],
      sub_category_list: [],
      sub_sub_category_list: [],
      search_by: 'relevancy', // relevancy, ctime, sales
      product_list: [],
      clone_list: [],
      total: 0,
      loading: false,
      download_loading: false,
      file_name: '',
      show_filter: false,
      product_filter: [
        {
          label: this.$t('base.price'),
          key: 'display_price',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('base.discount'),
          key: 'discount',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('base.sold'),
          key: 'historical_sold',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('tool.monthly_sold'),
          key: 'sold',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('tool.comments'),
          key: 'comment',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('tool.comments_sold_rate'),
          key: 'comment_x_historical_sold',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('base.stock'),
          key: 'stock',
          checked: true,
          expression: '>',
          value: null
        }
      ],
      price_min: null,
      price_max: null,

      sort_option: {
        order: null,
        prop: null
      },
      is_destroyed: false,

      interval: null,

      show_dialog: {
        models: false
      },
      loading_get_models: false,
      selected_product: {},
      selected_models: [],
      uniq_type: 'uniq',
      item_type: 'all',

      historical_sold: 0,
      revenue: 0,
      aov: 0,
      sold: 0,
      revenue_month: 0,
      aov_month: 0,
      view_count: 0,

      channel: 'shopee_analysis',
      feature: 'keyword_analysis',
      limit_request_number: 0,
      current_request_number: 0,

      is_filter_buff: false,

      notify: false
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_channel(['shopee_marketing_survey', 'shopee_analysis'])) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    this.notify = this.atosa_device === 'web'

    await this.m__get_shopee_categories()
    await this.m__get_limit_request_number()

    // todo: test
    this.$store.state.worker_id = '69ac72d7-7f76-4cb9-a9c6-8906f4b5f36c'
  },

  beforeDestroy() {
    this.is_destroyed = true

    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  watch: {
    'max': function (value) {
      if (value > 300) this.max = 300
    }
  },

  computed: {
    list_true() {
      let result = this.clone(this.product_list)

      if (this.is_filter_buff) {
        result = result.filter(i => !i.comment_x_historical_sold || i.comment_x_historical_sold > 12)
      }

      if (this.sort_option.order) {
        const {
          order,
          prop
        } = this.sort_option

        if (prop === 'price_max') {
          order === 'ascending' && result.sort((a, b) => a.price_max - b.price_max)
          order === 'descending' && result.sort((a, b) => b.price_max - a.price_max)
        }

        if (prop === 'discount') {
          order === 'ascending' && result.sort((a, b) => Math.floor(a.discount ? a.discount.replace('%', '') : 0) - Math.floor(b.discount ? b.discount.replace('%', '') : 0))
          order === 'descending' && result.sort((a, b) => Math.floor(b.discount ? b.discount.replace('%', '') : 0) - Math.floor(a.discount ? a.discount.replace('%', '') : 0))
        }

        if (prop === 'historical_sold') {
          order === 'ascending' && result.sort((a, b) => a.historical_sold - b.historical_sold)
          order === 'descending' && result.sort((a, b) => b.historical_sold - a.historical_sold)
        }

        if (prop === 'sold') {
          order === 'ascending' && result.sort((a, b) => a.sold - b.sold)
          order === 'descending' && result.sort((a, b) => b.sold - a.sold)
        }

        if (prop === 'stock') {
          order === 'ascending' && result.sort((a, b) => a.stock - b.stock)
          order === 'descending' && result.sort((a, b) => b.stock - a.stock)
        }

        if (prop === 'ctime') {
          order === 'ascending' && result.sort((a, b) => a.ctime - b.ctime)
          order === 'descending' && result.sort((a, b) => b.ctime - a.ctime)
        }

        if (prop === 'revenue') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.revenue - b.revenue)
          order === 'descending' && result.sort((a, b) => b.revenue - a.revenue)
        }

        if (prop === 'revenue_month') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.revenue_month - b.revenue_month)
          order === 'descending' && result.sort((a, b) => b.revenue_month - a.revenue_month)
        }

        if (prop === 'comment') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.comment - b.comment)
          order === 'descending' && result.sort((a, b) => b.comment - a.comment)
        }

        if (prop === 'comment_x_historical_sold') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.comment_x_historical_sold - b.comment_x_historical_sold)
          order === 'descending' && result.sort((a, b) => b.comment_x_historical_sold - a.comment_x_historical_sold)
        }

        if (prop === 'liked_count') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.liked_count - b.liked_count)
          order === 'descending' && result.sort((a, b) => b.liked_count - a.liked_count)
        }

        if (prop === 'rating') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.item_rating.rating_star - b.item_rating.rating_star)
          order === 'descending' && result.sort((a, b) => b.item_rating.rating_star - a.item_rating.rating_star)
        }

        if (prop === 'view_count') {
          order === 'ascending' && result.sort((a, b) => a.view_count - b.view_count)
          order === 'descending' && result.sort((a, b) => b.view_count - a.view_count)
        }

        if (prop === 'conversion_rate') {
          order === 'ascending' && result.sort((a, b) => a.conversion_rate - b.conversion_rate)
          order === 'descending' && result.sort((a, b) => b.conversion_rate - a.conversion_rate)
        }
      }

      const words = this.remove_unicode(this.filter.keyword)
      return _filter(result, item => item.itemid.toString().includes(words) || this.remove_unicode(item.name).includes(words) || item.item_type === words)
    },

    list_display() {
      const limit = this.filter.page_size
      const skip = limit * (this.filter.current_page - 1)

      return _take(_drop(this.list_true, skip), limit)
    }
  },

  methods: {
    m__remove_buff_orders() {
      for (const item of this.product_filter) {
        if (item.key === 'comment_x_historical_sold') {
          item.expression = '>'
          item.checked = true
          item.value = 18
        }
      }
      this.m__start_filter()
    },

    m__remove_product(index) {
      this.product_list.splice(index, 1)
    },

    m__short_value(value, is_percent) {
      if (this.loading.get_products) return '-'

      if (!value) return '0'
      if (!Number(value)) return '0.00'
      if (!is_percent) value = Math.floor(value)

      const one_thousand = 1000
      const one_million = one_thousand * one_thousand
      const one_billion = one_million * one_thousand

      let result = ''
      if (value >= one_billion) {
        result = `${(value / one_billion).toFixed(1)}b`
      } else if (value >= one_million) {
        result = `${(value / one_million).toFixed(1)}m`
      } else if (value >= one_thousand) {
        result = `${(value / one_thousand).toFixed(1)}k`
      } else {
        result = value
      }

      return `${result} ${is_percent ? '%' : ''}`
    },

    async m__get_limit_request_number() {
      const package_found = this.$store.state.package.extend_package.find(i => i.channel === this.channel)
      if (package_found && package_found.package.extra_data.request_limit) {
        this.limit_request_number = package_found && package_found.package.extra_data.request_limit
      }
      console.log('limit_request_number', this.limit_request_number)

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/limit_request/get', {
        channel: this.channel,
        feature: this.feature
      }, this.cf())
      this.current_request_number = response.body.data.count
      console.log('current_request_number', this.current_request_number)
    },

    async m__show_models_dialog(product) {
      this.selected_product = product
      this.selected_models = []

      if (!product.get_models) {
        this.loading_get_models = true
        try {
          // const response = await this.get_item({shop_id: product.shopid, item_id: product.itemid})
          const response = await this.xget_shopee(`/api/v4/pdp/get_pc?shop_id=${product.shopid}&item_id=${product.itemid}&detail_level=0`, {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "PDP.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          })
          if (!response || !response.data || !response.data.data || !response.data.data.data) {
            this.ntf_w(this.$t('tool.cannot_get_data'))
            this.loading_get_models = false
            return
          }

          // console.log(response)
          for (const item of response.data.data.data.item.models) {
            item.gmv = item.price / 100000 * item.sold
          }
          this.selected_models = response.data.data.data.item.models
          this.show_dialog.models = true
        } catch (e) {
          console.error(e)
        } finally {
          this.loading_get_models = false
        }
      }
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')
          const main_pagination = document.getElementById('main-pagination')

          const main_table = document.querySelector('div#main-table')
          const main_table_wrapper = document.querySelector('div#main-table div.el-table__body-wrapper')
          const scrollbar = document.getElementById('double-scroll-bar')

          const scrollbar_wrapper = document.getElementById('double-scroll-wrapper')
          scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'

          scrollbar.appendChild(document.createElement('div'))
          scrollbar.style.overflow = 'auto'
          scrollbar.style.overflowY = 'hidden'
          scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          this.interval = setInterval(() => {
            scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
            scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          }, 1000)
          scrollbar.firstChild.style.paddingTop = '1px'
          scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
          scrollbar.onscroll = () => {
            main_table_wrapper.scrollLeft = scrollbar.scrollLeft
          }
          main_table_wrapper.onscroll = () => {
            scrollbar.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect = main_pagination.getBoundingClientRect()
            const elem_top = rect.top
            const is_visible = elem_top <= window.innerHeight
            if (is_visible) {
              scrollbar_wrapper.style.zIndex = '-1'
            } else {
              scrollbar_wrapper.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    async m__suggest_keyword(queryString, cb) {
      cb([])
      return

      if (!queryString) {
        cb([])
        return
      }
      const hint_keywords = await this.request_to_shopee({
        url: `https://shopee.vn/api/v4/search/search_hint?keyword=${encodeURIComponent(queryString)}&search_type=0&version=1`
      })
      if (hint_keywords && hint_keywords.body && hint_keywords.body.data && hint_keywords.body.data.keywords) {
        cb(hint_keywords.body.data.keywords.map(i => ({value: i.keyword})))
      } else {
        cb([])
      }
    },

    m__show_filter_dialog() {
      this.show_filter = true
    },

    m__delete_filter() {
      this.product_list = [...this.clone_list]
      this.product_filter.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.show_filter = false
    },

    m__start_filter() {
      this.product_list = [...this.clone_list]
      let any_change = false
      for (const item of this.product_filter) {
        if (item.value) {
          any_change = true
          this.product_list = this.product_list.filter(i => i[item.key] && eval(`${i[item.key]}
          ${item.expression}
          ${item.value}`))
        }
      }
      if (!any_change) {
        this.product_list = [...this.clone_list]
      }
      this.show_filter = false
    },

    async m__get_shopee_categories() {
      this.category_list = shopee_category_list.data.data
    },

    m__select_category(cat) {
      if (this.loading) {
        return
      }

      if (this.selected_category === cat.main.catid) {
        this.selected_category = ''
        this.selected_sub_category = ''
        this.selected_sub_sub_category = ''
        this.sub_category_list = []
        this.sub_sub_category_list = []
      } else {
        this.selected_category = cat.main.catid
        const category = this.category_list.find(i => i.main.catid === cat.main.catid)
        this.sub_category_list = category.sub
      }
    },

    m__is_selected_cat(cat) {
      return this.selected_category === cat.main.catid
    },

    m__select_sub_category(sub_cat) {
      if (this.loading) {
        return
      }

      if (this.selected_sub_category === sub_cat.catid) {
        this.selected_sub_category = ''
        this.selected_sub_sub_category = ''
        this.sub_sub_category_list = []
      } else {
        this.selected_sub_category = sub_cat.catid
        this.sub_sub_category_list = sub_cat.sub_sub
      }
    },

    m__is_selected_sub_cat(sub_cat) {
      return this.selected_sub_category === sub_cat.catid
    },

    m__select_sub_sub_category(sub_sub_cat) {
      if (this.loading) {
        return
      }

      if (this.selected_sub_sub_category === sub_sub_cat.catid) {
        this.selected_sub_sub_category = ''
      } else {
        this.selected_sub_sub_category = sub_sub_cat.catid
      }
    },

    m__is_selected_sub_sub_cat(sub_sub_cat) {
      return this.selected_sub_sub_category === sub_sub_cat.catid
    },

    m__create_product_link(product) {
      return `https://shopee.vn/product-i.${product.shopid}.${product.itemid}`
      // const reg = /[\s\/.?#\[\]%&]+/g
      // return `https://shopee.vn/${product.name.replace(reg, '-')}-i.${this.shop_id}.${product.itemid}/`
    },

    m__get_day(item) {
      return Math.abs(this.dayjs(new Date(item.ctime * 1000)).diff(this.dayjs(), 'd'))
    },

    async m__start_search() {
      if (this.limit_request_number && this.current_request_number >= this.limit_request_number) {
        this.ntf_w(this.$t('tool.limit_package_message'))
        return
      }

      if (!this.search_keyword && !this.selected_category && !this.selected_sub_category) {
        return
      }

      this.loading = !this.loading
      if (this.is_destroyed || !this.loading) {
        return
      }

      if (!this.max || this.max > 300) this.max = 300

      this.product_list = []
      this.clone_list = []

      let limit = 60, newest = 0
      const keyword = this.search_keyword
      const match_id = this.selected_sub_sub_category || this.selected_sub_category || this.selected_category || ''
      const price_min = this.price_min || ''
      const price_max = this.price_max || ''
      const view_session_id = this.make_view_session_id()
      const query = {
        by: this.search_by,
        keyword: encodeURIComponent(keyword.normalize()),
        newest,
        limit,
        order: 'desc',
        page_type: 'search',
        scenario: 'PAGE_GLOBAL_SEARCH',
        version: 2,
        view_session_id
      }

      if (match_id) query['match_id'] = match_id
      if (price_min) query['price_min'] = price_min
      if (price_max) query['price_max'] = price_max

      try {
        // let response = await this.search_items({
        //   device: 'website',
        //   qs: query
        // }, true)
        let path = '/api/v4/search/search_items?' + Object.keys(query).map(k => `${k}=${query[k]}`).join('&');
        let response = await this.xget_shopee(path, {
          "antiFraudConfig": {
            "antiCrawler": {
              "appKey": "Search.PC",
              "shouldReplaceHistory": true,
              "redirectType": "1"
            },
            "deviceFingerPrint": {},
            "apiProtection": {}
          }
        })
        if (!response || !response.data) {
          this.ntf_w(this.$t('tool.cannot_get_data'))
          this.loading = false
          return
        }

        if (!response.data.data || !response.data.data.items) {
          this.ntf_w(this.$t('tool.cannot_get_data'))
          this.loading = false
          return
        }

        // console.log(response)
        response = {body: response.data}

        this.m__generate_scrollbar()

        this.total = response.body.data.total_count

        let index = 1;
        for (const item of response.body.data.items) {
          if (this.is_destroyed || !this.loading) break

          Object.assign(item, item.item_basic)
          delete item.item_basic

          item.display_price = item.price_max / 100000
          item.revenue = item.price_max / 100000 * item.historical_sold
          item.revenue_month = item.price_max / 100000 * item.sold
          item.comment = item.item_rating.rating_count[0]
          item.item_type = item.adsid ? 'ads' : 'seo'
          item.comment_x_historical_sold = item.historical_sold ? parseFloat((item.comment / item.historical_sold * 100).toFixed(2)) : 0

          if (this.item_type === 'seo') {
            if (item.item_type === 'seo' && !this.product_list.some(i => i.itemid === item.itemid)) {
              item.index = index++
              this.product_list.push(item)
            }
          } else {
            item.index = index++
            this.product_list.push(item)
          }

          if (this.max && this.product_list.length >= this.max) {
            break
          }
        }

        while (this.loading && !this.is_destroyed) {
          if (this.max && this.product_list.length >= this.max) {
            break
          }
          if (!response.body.data.items.length) {
            break
          }

          // query.newest += limit
          // response = await this.search_items({
          //   device: 'website',
          //   qs: query
          // }, true)

          query.newest += limit
          path = '/api/v4/search/search_items?' + Object.keys(query).map(k => `${k}=${query[k]}`).join('&');
          response = await this.xget_shopee(path, {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "Search.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          })
          if (!response || !response.data) {
            this.ntf_w(this.$t('tool.cannot_get_data'))
            this.loading = false
            break
          }

          // console.log(response)
          response = {body: response.data}

          for (const item of response.body.data.items) {
            if (this.is_destroyed || !this.loading) break

            Object.assign(item, item.item_basic)
            delete item.item_basic

            item.display_price = item.price_max / 100000
            item.revenue = item.price_max / 100000 * item.historical_sold
            item.revenue_month = item.price_max / 100000 * item.sold
            item.comment = item.item_rating.rating_count[0]
            item.item_type = item.adsid ? 'ads' : 'seo'
            item.comment_x_historical_sold = item.historical_sold ? parseFloat((item.comment / item.historical_sold * 100).toFixed(2)) : 0

            if (this.item_type === 'seo') {
              if (item.item_type === 'seo' && !this.product_list.some(i => i.itemid === item.itemid)) {
                item.index = index++
                this.product_list.push(item)
              }
            } else {
              item.index = index++
              this.product_list.push(item)
            }

            if (this.max && this.product_list.length >= this.max) {
              break
            }
          }

          await this.sleep(1000)
        }

        [this.historical_sold, this.revenue, this.sold, this.revenue_month, this.view_count] = this.product_list.reduce((result, item) => {
          result[0] += item.historical_sold
          result[1] += item.revenue
          result[2] += item.sold
          result[3] += item.revenue_month
          result[4] += item.view_count

          return result
        }, [0, 0, 0, 0, 0])

        this.aov = this.historical_sold ? Math.floor(this.revenue / this.historical_sold) : 0
        this.aov_month = this.sold ? Math.floor(this.revenue_month / this.sold) : 0

        if (this.product_list.length) {
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/limit_request/save', {
            channel: this.channel,
            feature: this.feature
          }, this.cf())
          await this.m__get_limit_request_number()
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('tool.cannot_get_data'))
      }

      this.loading = false
      this.clone_list = [...this.product_list]

      this.ntf_s(this.$t('tool.analyze_success'))
    },

    async m__get_product_detail(itemid, shopid) {
      const response = await this.request_to_shopee({
        url: `https://shopee.vn/api/v4/item/get?itemid=${itemid}&shopid=${shopid}`
      })
      if (response.body.data && response.body.data.data) {
        return response.body.data.data
      }

      return null
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    async m__show_download_excel() {
      try {
        this.download_loading = true
        this.file_name = `data-report-time-${this.dayjs().format('DD_MM_YYYY HH_mm')}`

        const value = await this.$prompt(this.$t('input.filename'), this.$t('base.download_excel'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          inputValue: this.file_name
        })

        if (value) {
          await this.m__download_excel(this.list_true, false)
        } else {
          this.ntf_w(this.$t('required.filename'))
        }
      } catch (e) {
        console.error(e)
        if (e !== 'close') {
          this.ntf_w(this.$t('base.has_an_occurred'))
        }
      } finally {
        this.download_loading = false
      }
    },

    async m__download_excel(products) {
      try {
        const export_url = this.API.URL_API_SRV_2 + '/mipee/excel'
        const response = await this.$http.post(export_url, {
          product_list: products,
          name: this.file_name
        }, {
          ...this.cf(),
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.file_name}.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style>
.selected_cat {
  border: 2px dashed orangered !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/tool/survey.vue